import React, { useState, useEffect, useCallback } from 'react';
import { CircularProgress, makeStyles } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
import LockIcon from 'assets/icons/LockIcon.svg';
import DigitalLockIcon from 'assets/icons/DigitalLockIcon.svg';
import CityIcon from 'assets/icons/CityIcon.svg';
import CngIcon from 'assets/icons/CngIcon.svg';
import FlatBedTruckIcon from 'assets/icons/FlatBedTruckIcon.svg';
import ForkLiftingIcon from 'assets/icons/ForkLiftingIcon.svg';
import GpsRouteIcon from 'assets/icons/GpsRouteIcon.svg';
import HookIcon from 'assets/icons/HookIcon.svg';
import NoBedTruckIcon from 'assets/icons/NoBedTruckIcon.svg';
import ShinyFloorIcon from 'assets/icons/ShinyFloorIcon.svg';
import apiCaller from '../../../../utils/apiCallerOutstanding';
import myFirebase from '../../../../config/config';
import logger from '../../../../utils/logger';

const useStyles = makeStyles(theme => ({
  flexBox: {
    display: 'flex',
    gap: '5px',
    flexWrap: 'wrap',
    marginTop: '5px',
  },
}));

const OtherRequirements = ({ transactionId, stylesClass }) => {
  const [requirementsData, setRequirementsData] = useState({});
  const [loading, setLoading] = useState(false);
  const classes = useStyles();

  const requirementsOptions = [
    {
      name: 'Central Lock',
      icon: LockIcon,
      isAvailable: requirementsData?.is_central_lock,
    },
    {
      name: 'City Loading',
      icon: CityIcon,
      isAvailable: requirementsData?.is_city_loading,
    },
    {
      name: 'City Unloading',
      icon: LockIcon,
      isAvailable: requirementsData?.is_city_unloading,
    },
    {
      name: 'Digital Lock',
      icon: DigitalLockIcon,
      isAvailable: requirementsData?.is_digital_lock,
    },
    {
      name: 'Forklift Loading',
      icon: ForkLiftingIcon,
      isAvailable: requirementsData?.is_forklift_loading,
    },
    {
      name: 'GPS Required',
      icon: GpsRouteIcon,
      isAvailable: requirementsData?.is_gps_required,
    },
    {
      name: 'Hooks',
      icon: HookIcon,
      isAvailable: requirementsData?.is_hooks,
    },
    {
      name: 'No Bedding',

      icon: NoBedTruckIcon,
      isAvailable: requirementsData?.is_no_bedding,
    },
    {
      name: 'Non-CNG',
      icon: CngIcon,

      isAvailable: requirementsData?.is_non_cng,
    },
    {
      name: 'Smooth Flooring',
      icon: ShinyFloorIcon,
      isAvailable: requirementsData?.is_smooth_flooring,
    },
    {
      name: 'Steel Platform',
      icon: FlatBedTruckIcon,
      isAvailable: requirementsData?.is_steel_platform,
    },
  ];

  const view = useCallback(async () => {
    setLoading(true);
    const userDetails = myFirebase.auth().currentUser;
    const { Aa: userToken } = userDetails;
    const endPoint = `pipe/demand-additional-requirements?transaction_id=${transactionId}`;
    try {
      const response = await apiCaller(
        endPoint,
        {},
        `Bearer ${userToken}`,
        'nh-base',
        'get'
      );
      const data = response?.data?.data;
      setRequirementsData(data);
    } catch (error) {
      logger.error(`Error Transaction's Other Requirements`, error);
    } finally {
      setLoading(false);
    }
  }, [transactionId]);

  const availableOptions = requirementsOptions.filter(
    option => option.isAvailable
  );

  useEffect(() => {
    view();
  }, [view]);

  if (loading) {
    return <CircularProgress size={15} />;
  }

  if (availableOptions.length === 0) {
    return <div>–</div>;
  }

  return (
    <div className={classes.flexBox}>
      {requirementsOptions.map(
        option =>
          option.isAvailable && (
            <div key={option.name}>
              <Chip
                icon={
                  <img
                    src={option.icon}
                    alt=""
                    style={{ width: 16, height: 16 }}
                  />
                }
                label={option.name}
                variant="outlined"
                size="medium"
                style={{
                  fontSize: '12px',
                  fontWeight: 400,
                  borderRadius: '7px',
                }}
              />
            </div>
          )
      )}
    </div>
  );
};

export default OtherRequirements;
